
import React, { useContext } from 'react';
import { SettingsSearchContext } from './SettingsContext';

interface ControlGroupProps {
  label: string;
  children?: React.ReactNode;
  value?: string | number;
}

export const ControlGroup: React.FC<ControlGroupProps> = ({ label, children, value }) => {
  const searchQuery = useContext(SettingsSearchContext);

  if (searchQuery && !label.toLowerCase().includes(searchQuery.toLowerCase())) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1.5 w-full mb-2">
      <div className="flex justify-between items-center">
        <label className="text-[9px] uppercase font-black tracking-widest opacity-50">{label}</label>
        {value !== undefined && <span className="text-[9px] font-mono font-bold opacity-80">{value}</span>}
      </div>
      {children}
    </div>
  );
};
